/**
 * Error boundary component exports
 *
 * @since 1.0.0
 */

export { CartPopupErrorBoundary } from './component';
export type { ErrorBoundaryProps, ErrorBoundaryState } from './types';
